import type { DataOption } from '@/common.types'

import { map, paths, pick, pipe } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { getAnchorsTypesChoices } from '@/entities/anchor'
import {
	getSalesEntitiesTree,
	useOptimizationGroupsQuery,
	useSalesEntitiesQuery,
} from '@/entities/optimization-group'

import { toOption } from '@/shared/tools/utils'

import { getAnchorStatusChoices } from './constants'

export const useApprovalTableDataChoices = () => {
	const { t } = useTranslation()

	const optimizationGroupsQuery = useOptimizationGroupsQuery<DataOption[]>({
		select: pipe(map(paths(['id', 'name'])), toOption),
	})
	const salesEntitiesQuery = useSalesEntitiesQuery()

	return {
		anchor_type: map(
			pick(['value', 'label']),
			getAnchorsTypesChoices(t)
		) as DataOption[],
		optimization_group_id: optimizationGroupsQuery.data || [],
		sales_entity_id: getSalesEntitiesTree(salesEntitiesQuery.data) || [],
		status: map(
			pick(['value', 'label']),
			getAnchorStatusChoices(t)
		) as DataOption[],
	}
}
